import React from "react";

export function PageHeader({ eyebrow, title, subtitle, children, testid }) {
  return (
    <div className="px-4 md:px-10 pt-6 md:pt-8 pb-5 md:pb-6 border-b border-zinc-900" data-testid={testid}>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="max-w-2xl">
          {eyebrow ? (
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-orange-500 mb-2">
              {eyebrow}
            </div>
          ) : null}
          <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-semibold text-zinc-50 tracking-tight">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{subtitle}</p>
          ) : null}
        </div>
        {children ? <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">{children}</div> : null}
      </div>
    </div>
  );
}
